var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"check"),React.createElement("path",{"fill":"#2ab27b","d":"M-176.5,368.8c-1.4-1.2-3.2-1.9-5-1.7c-1.9,0.2-3.6,1.1-4.7,2.6l0,0l-31.7,40.1l-14.1-18.4c-1.1-1.5-2.9-2.4-4.7-2.6\r\n\tc-1.8-0.1-3.6,0.5-5,1.7c-2.8,2.6-3.1,6.9-0.7,9.9l17.9,23.4c2.9,3.7,8.3,4.3,12,1.4c0.5-0.4,1-0.9,1.4-1.4l35.5-45\r\n\tC-173.2,375.8-173.6,371.4-176.5,368.8z","key":1})]);
}

Check.defaultProps = {"version":"1.1","id":"svg_2px","x":"0px","y":"0px","viewBox":"-257 349 96 96","style":{"enableBackground":"new -257 349 96 96"},"xmlSpace":"preserve"};

module.exports = Check;

Check.default = Check;
